import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getHotVacancyList = createAsyncThunk(
    "getHotVacancyList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/job/hot-vacancy-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const HotVacancySlice = createSlice({
    name: "HotVacancySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getHotVacancyList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getHotVacancyList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getHotVacancyList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default HotVacancySlice.reducer;
